import { Bundle, ScheduleLineGroup, ScheduleLineGroupData } from '@paragon/contract-library';

import { DesignService } from '../connections';

export function get(guid: string) {
  return DesignService.get<ScheduleLineGroup>(`scheduleLineGroups/${guid}`);
}

export function getForOrganization() {
  return DesignService.get<readonly ScheduleLineGroup[]>(`scheduleLineGroups/forOrganization`);
}

export function getActiveScheduleLineGroups(stationGuid: string) {
  return DesignService.get<readonly ScheduleLineGroup[]>(
    `public/scheduleLineGroups/getActiveScheduleLineGroupsByStation/${stationGuid}`,
  );
}

export function getScheduleLineGroupData(guid: string) {
  return DesignService.get<ScheduleLineGroupData>(`public/scheduleLineGroups/${guid}/getScheduleLineGroupData`);
}

export function getFloorChordMemberProductionDetail(guid: string) {
  return DesignService.get<ScheduleLineGroupData>(
    `public/scheduleLineGroups/${guid}/getFloorChordMemberProductionDetail`,
  );
}

export function insert(name: string, lineGuid: string, scheduledDate: string | null) {
  return DesignService.post<ScheduleLineGroup>('scheduleLineGroups', { data: { name, lineGuid, scheduledDate } });
}

export function update(scheduleLineGroup: ScheduleLineGroup) {
  return DesignService.put<void>('scheduleLineGroups', { data: scheduleLineGroup });
}

export function remove(guid: string) {
  return DesignService.delete<readonly Bundle[]>(`scheduleLineGroups/${guid}`);
}

export function updatePriorities(updatedPriorities: { [scheduleLineGroupGuid: string]: number }) {
  return DesignService.post<readonly ScheduleLineGroup[]>('scheduleLineGroups/updatePriorities', {
    data: updatedPriorities,
  });
}
